import BpkLink from '@skyscanner/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
  TEXT_COLORS,
} from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';

import { iconsMap } from '../../InfoSnippetDecoupled/Snippet';
import { useMBDContext } from '../../common/MBD/useMBDContext';

import type { CheapestTimeToSnippetProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CheapestTimeToProps';

import STYLES from './Snippet.module.scss';

type CheapestTimeToSnippetMbdProps = {
  mbdComponentName: string;
  index?: number;
};

const Snippet = ({
  dofollow,
  icon,
  id,
  index = undefined,
  label,
  linkUrl,
  mbdComponentName,
  value,
}: CheapestTimeToSnippetProps & CheapestTimeToSnippetMbdProps) => {
  const EmptyIcon = () => null;
  const Icon = iconsMap[icon] || EmptyIcon;

  const { buildMBDParam } = useMBDContext();

  const relProps = dofollow ? {} : { rel: 'nofollow' };

  return (
    <div
      className={STYLES.Snippet}
      data-testid="cheapestTimeToSnippet"
      // Use MBD component name provided by the parent component instead of from MBD context,
      // as this snippet has no context to know what specific kind of snippet it is
      data-tracking-element-id={
        index !== undefined ? `${mbdComponentName}_${index}` : mbdComponentName
      }
      data-tracking-common-params={buildMBDParam(mbdComponentName, {
        snippet_id: id ?? '',
      })}
    >
      <Icon className={STYLES.Snippet__icon} />
      <BpkText
        color={TEXT_COLORS.textPrimary}
        className={STYLES.Snippet__title}
        textStyle={TEXT_STYLES.bodyDefault}
      >
        {label}
      </BpkText>
      {linkUrl ? (
        <BpkLink
          data-testid="linkurl"
          className={STYLES.Snippet__linkBody}
          href={linkUrl}
          {...relProps}
        >
          {value}
        </BpkLink>
      ) : (
        <BpkText textStyle={TEXT_STYLES.heading4}>{value}</BpkText>
      )}
    </div>
  );
};

export default Snippet;
